<p class="centered">
  HEADER
</p>

<hr>

<style>

.centered {
  text-align: center;
  margin-top: 0px;
}

hr {
  border-top: 1px solid #DDD;
}

</style>